import { Routes, Route } from 'react-router-dom';
import { ROUTE_ELEMENTS } from './routeElements';
import { ROUTE_KEYS } from './routeKeys';
import { ROUTE_PATHS } from './routePaths';
import { TitleWrapper } from './TitleWrapper';
import { ROUTE_TITLES } from './routeTitles';
import { PageLayout } from '../components/PageLayout';

function Router() {
    return (
        <Routes>
            {ROUTE_KEYS.map((routeKey) => {
                const { element, hideFrieze } = ROUTE_ELEMENTS[routeKey];
                const { path } = ROUTE_PATHS[routeKey];
                const documentTitle = ROUTE_TITLES[routeKey];

                return (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <TitleWrapper documentTitle={documentTitle}>
                                <PageLayout hideFrieze={hideFrieze}>{element}</PageLayout>
                            </TitleWrapper>
                        }
                    />
                );
            })}
        </Routes>
    );
}

export { Router };
